import Aria from "../../util/Aria";
import { Timeout, addCSSRule, dateFormatter, generateBackgroundImgUrl } from "../../util/Misc";
import { objToStyleMap } from "../../shoutui/utils";
import { Constants } from "../../model/Constants";
import { renderRichMediaWidget } from "./controller/BubbleController";
import BubbleType from "../../model/BubbleType";
import {customerbubbleRender} from "../templates/renders/customerbubble";

/**
 * Creates the customer-bubble custom element that is created for every customer message
 * @type {{template, created(): void, tagName: string, udpateBackground(*=): void}}
 */
const CustomerBubble: any = {
    tagName: "customer-bubble",
    initialize(options) {
        initComponent(options);
    },
    renderer: customerbubbleRender,
    created() {
        this.ariaUtil = new Aria(this.$app);

        this.bubble = this.el.querySelector(".customer-bubble");

        if (this.prop.restore === "true" || this.$app.getRestoring()) {
            this.bubble.classList.add("enter");
        } else {
            Timeout.set("animatetimer", () => {
                this.bubble.classList.add("enter");
            }, 25);
            this.announceAria();
        }

        if (this.backgroundImg) {
            this.udpateBackground(this.backgroundImg);
        }
    },
    udpateBackground(propObj) {
        const imgUrl = generateBackgroundImgUrl(propObj, this.$app);

        if (imgUrl) {
            this.bubble.style.backgroundImage = imgUrl;
        }
    },

    /**
     * creates and return the RichEngine instance
     * @param {Message} message
     * @param {Object} richData
     * @return {RichMain}
     */
    setRichObject(message, richData) {
        if (window.RichMain) {
            this.richInstance = window.RichMain.instance;
            const richElement = document.createElement("div");
            const isRestore = this.prop.restore === "true";
            const shouldLock = richData.customerAction ? true : isRestore;
            const jsonSpec = richData.customerAction ? richData.receipt : richData;

            renderRichMediaWidget(this.richInstance, this.$app, jsonSpec,
                richElement, shouldLock, false, ariaOutputs => {
                    if (!isRestore) {
                        this.ariaUtil.announceRichDataMessage(ariaOutputs);
                    }
                });

            if (richData.customerAction && !message.getIsRestore()) {
                Timeout.set("richRTimer", () => {
                    this.$app.getSDKInstance().sendRichContentMessage(
                        message.getMessageText(),
                        richData
                    );
                }, this.richWidgetReceiptTimer);
            }

            if (this.namePos == Constants.WITHIN_BOTTOM || this.timePos == Constants.WITHIN_BOTTOM) {
                this.bubble.insertBefore(richElement, this.bubble.lastElementChild);
            } else {
                this.bubble.appendChild(richElement);
            }
            return this.richInstance;
        }
        return null;
    },
    hideBottomInfo() {
        if (this.gTime && this.timePos == Constants.WITHIN_BOTTOM) {
            this.hideTime();
        }

        if (this.gAlias && this.namePos == Constants.WITHIN_BOTTOM) {
            this.hideAlias();
        }
    },
    hideTopInfo() {
        if (this.gTime && this.timePos == Constants.WITHIN_TOP) {
            this.hideTime();
        }

        if (this.gAlias && this.namePos == Constants.WITHIN_TOP) {
            this.hideAlias();
        }
    },
    hideTime() {
        const timeSpan = this.bubble.querySelector(".msg-info-time span");

        if (timeSpan) {
            timeSpan.style.display = "none";
        }
    },
    hideAlias() {
        const nameSpan = this.bubble.querySelector(".msg-info-name span");

        if (nameSpan) {
            nameSpan.style.display = "none";
        }
    },
    announceAria() {
        this.ariaUtil.announceBubbleText(this.prop.messagetext, this.prop.name);
    },
    getType(): number {
        return BubbleType.CUSTOMER_MESSAGE;
    }
};

/**
 * @export CustomerBubble
 * @param {CIApp} appInstance
 * @return {{template, created, (): void, tagName: string, udpateBackground, (*=): void}}
 */
export default appInstance => {
    const constObj: any = {};
    CustomerBubble.$app = appInstance;
    CustomerBubble.constants = constObj;
    return CustomerBubble;
};

const initComponent = (options: any) => {
    const appInstance = options.$app;
    const config = appInstance.getUIConfig();
    const constObj: any = options.constants;

    if (config.transcriptConfig) {
        const tConfig = config.transcriptConfig;
        constObj.style = tConfig.customerBubbleStyles;
        constObj.nameStyle = tConfig.customerNameStyles;
        constObj.timeStyle = tConfig.dateTimeStyles;
        constObj.backgroundImg = tConfig.customerBackgroundImageConfig;
        constObj.textAlignment = tConfig.customerTextAlignment || "right";

        if (tConfig.customerBubbleAfterStyles) {
            const after = objToStyleMap(tConfig.customerBubbleAfterStyles);
            addCSSRule(document.styleSheets[0], ".customer-bubble:after", after);
        }

        if (tConfig.customerBubbleBeforeStyles) {
            const before = objToStyleMap(tConfig.customerBubbleBeforeStyles);
            addCSSRule(document.styleSheets[0], ".customer-bubble:before", before);
        }
    }

    const appConfig = appInstance.getUIConfig().appConfigProps;

    if (appConfig) {
        constObj.hugging = appConfig.enableHugging;
        constObj.showName = appConfig.displayCustomerName;
        constObj.namePos = appConfig.customerNamePosition;
        constObj.showTime = appConfig.displayDateAndTime;
        constObj.timePos = appConfig.dateTimePosition;
        constObj.gTime = appConfig.enableMsgGroupingDateTime && appConfig.enableMsgGrouping;
        constObj.gAlias = appConfig.enableMsgGroupingCustomerAlias && appConfig.enableMsgGrouping;
    }

    options.data = {
        timeText: state => dateFormatter(parseInt(state.prop.timestamp, 10),
            (appConfig && appConfig.timeStampFormat) || "HH:mm"),
    };

    constObj.richWidgetReceiptTimer = (config.appConfigProps && config.appConfigProps.richWidgetReceiptTimer) || 50;
};
